<template>
  <div id="accountList">
    <div class="title_bar">
      <div class="left" />
      <div class="right">
        <el-button
          icon="icon-plus"
          round
          @click="openDialog('open')"
        >
          開通人員
        </el-button>
      </div>
    </div>
    <el-table
      class="newslist"
      :data="ListData"
      empty-text="目前無任何帳號"
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        prop="Name"
        label="姓名"
      >
        <template slot-scope="scope">
          <div class="nameWrap">
            <span>{{ scope.row.Name }}</span>
            <el-tooltip
              v-if="scope.row.EnableAlert && scope.row.needAlert"
              effect="dark"
              placement="bottom"
            >
              <div slot="content">
                此帳號已多日未上線，為維護貴<br>社區資料安全建議解除開通<br>
                <el-link
                  style="float: right; color: #fff; font-weight: normal;"
                  @click="closeRemind(scope.row.Id, scope.$index)"
                >
                  不再提醒
                </el-link>
              </div>
              <i
                class="icon-info"
                aria-hidden="true"
              />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="AccountType"
        label="身份"
      >
        <template slot-scope="scope">
          {{ filterAccountType(scope.row.AccountType) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="CarrierCount"
        label="載具數量"
        align="center"
      />
      <el-table-column
        prop="OpenAt"
        label="開通時間"
      >
        <template slot-scope="scope">
          {{ scope.row.OpenAt.split(':')[0] }}:{{ scope.row.OpenAt.split(':')[1] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="LastLoginAt"
        label="最後登入時間"
      >
        <template slot-scope="scope">
          <span :class="{'alertHighlight': scope.row.needAlert}">{{ scope.row.LastLoginAt ? `${scope.row.LastLoginAt.split(':')[0]}:${scope.row.LastLoginAt.split(':')[1]}` : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="操作"
        width="320"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            @click="openDialog('edit', scope.row)"
          >
            編輯權限
          </el-button>
          <el-button
            size="mini"
            plain
            @click="openDeviceDialog(scope.row)"
          >
            載具管理
          </el-button>
          <el-button
            size="mini"
            :class="{'disable': scope.row.Myself}"
            type="danger"
            plain
            @click="delOpen(scope.row.Id, scope.$index)"
          >
            解除開通
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <AuthDialog
      ref="authDialog"
      :account="selectedAccount"
    />
    <DeviceDialog
      ref="deviceDialog"
      :account="selectedAccount"
      @setDeviceCount="setDeviceCount"
      @getDeviceList="getDevices"
    />
  </div>
</template>
<script>
import { firebaseConfig } from '@/config'
import { getApps, initializeApp } from 'firebase/app'
import { getDatabase, ref, set } from 'firebase/database'
import TableLoading from '@/components/TableLoading'
import AuthDialog from './components/AuthDialog.vue'
import DeviceDialog from './components/DeviceDialog.vue'
export default {
  components: {
    AuthDialog,
    DeviceDialog,
    TableLoading
  },
  data () {
    return {
      activeName: 'accountList',
      scrollEnd: false,
      loading: false,
      offset: 0,
      maxCount: 10,
      ListData: [],
      selectedAccount: null
    }
  },
  mounted () {
    if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount && !JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip) {
      this.$alert('沒有訪問權限', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.$router.back()
      })
      return false
    }
    window.addEventListener('scroll', this.autoShow, true)
    this.getAccounts()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    // 下拉到底自動載入
    autoShow () {
      // 視窗滾動條高度
      const ScrollTop = document.documentElement.scrollTop
      // console.log(`視窗滾動條高度:${ScrollTop}`)
      // 視窗可視範圍高度
      const ClientHeight = document.documentElement.clientHeight
      // console.log(`視窗可視範圍高度:${ClientHeight}`)
      // 內容實際高度
      const ScrollHeight = document.documentElement.scrollHeight
      // console.log(`內容實際高度:${ScrollHeight}`)

      // console.log(ScrollTop+ClientHeight +" : "+ ScrollHeight)
      // console.log(`${ScrollTop+ClientHeight}:${ScrollHeight}`)
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'accountList') {
        if (!this.scrollEnd) {
          this.offset += 10
          this.$handleScroll(this.getAccounts)
        }
      }
    },
    openDialog (mode, account) {
      if (mode === 'open') {
        this.selectedAccount = null
      } else if (mode === 'edit') {
        this.selectedAccount = account
      }
      this.$refs.authDialog.openDialog(mode)
    },
    delOpen (id, index) {
      this.$confirm('解除開通後，該帳號即無法登入貴社區管理後台，是否確定解除開通？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationAccounts/${id}`
        axios(url, {
          method: 'DELETE',
          headers: {
            kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
          }
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          kingetcareFb = getApps().filter(x => x.name == 'kingnetcare').length == 1 ? getApps().filter(x => x.name == 'kingnetcare')[0] : initializeApp(firebaseConfig, 'kingnetcare')
          const database = getDatabase(kingetcareFb)
          const reference = ref(database, `AppMonitor/${this.ListData[index].Account}/`)
          set(reference, { Authorization: true })
          this.ListData.splice(index, 1)
        }).catch(err => {
          console.log(err, err.response)
          if (err.response.status === 401 || !JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
            this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            }).then(() => {
              this.$logoutCommunity()
            })
          }
        })
      }).catch(() => {
        console.log('delete fail')
      })
    },
    closeRemind (id, index) {
      const url = `${process.env.VUE_APP_CORE_URL}/PassiveUse/CancelAlert`
      axios(url, {
        method: 'POST',
        headers: {
          kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
        },
        data: {
          AuthorizationId: id
        }
      }).then(res => {
        this.ListData[index].EnableAlert = false
        this.ListData[index].needAlert = false
      }).catch(err => {
        console.log(err.response)
        if (err.response.status === 401 || !JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        }
      })
    },
    getAccounts () {
      const url = `${process.env.VUE_APP_CORE_URL}/api/AuthorizationAccounts`
      this.loading = true
      const data = {
        offset: this.offset,
        maxCount: this.maxCount
      }
      return axios(url, {
        method: 'GET',
        headers: {
          kingnetauth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}`
        },
        params: data
      }).then(async (res) => {
        console.log(res.data.Data)
        if (res.data.Data.AuthoruzatuinAccounts.length !== 0) {
          const tempArr = res.data.Data.AuthoruzatuinAccounts
          await this.$sleep(1000, res.duration)
          tempArr.forEach(item => {
            const today = new Date()
            if (item.EnableAlert) {
              item.needAlert = new Date(today.setDate(today.getDate() - 14)) > new Date(item.LastLoginAt)
            }
          })
          this.ListData = [...this.ListData, ...tempArr]
          if (res.data.Data.AuthoruzatuinAccounts.length < 10) {
            this.scrollEnd = true
          }
        } else {
          this.scrollEnd = true
        }
        this.loading = false
        return true
      }).catch(err => {
        console.log(err.response)
        if (err.response.status === 401 || !JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        } else {
          this.$alert('沒有訪問權限', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$router.back()
          })
        }
        return false
      })
    },
    filterAccountType (type) {
      switch (type) {
        case 1:
          return '最高管理者'
        case 2:
          return '一般管理者'
      }
    },
    openDeviceDialog (account) {
      this.selectedAccount = account
      this.getDevices()
      this.$refs.deviceDialog.openDialog()
    },
    getDevices () {
      apiManagement.GetDeviceList({
        id: this.selectedAccount.Id
      })
        .then(res => {
          this.$refs.deviceDialog.listData = res.data.Data.Carriers
        })
    },
    setDeviceCount ({ id, count }) {
      const index = this.ListData.findIndex(item => item.Id === id)
      this.ListData[index].CarrierCount += count
    }
  }
}
</script>

<style lang="sass" scoped>
#accountList
  text-align: center
  padding: 20px 0 10px
  height: 100%
  .title_bar
    display: flex
    justify-content: space-between
    align-items: center
    margin: 0 0 20px 0
    .introduction
      color: $mainColorDark
      font-size: 20px
      font-weight: initial
      margin: 0 10px
      text-decoration: underline
      cursor: pointer
      &:before
        content: '('
        color: #000
      &:after
        content: ')'
        color: #000
    .questionnaire
      background-color: $bgDark3
      padding: 5px 8px
      span
        color: $mainColor
        cursor: pointer
        margin: 0 10px 0 13px
    .title
      font-weight: bold
      font-size: map-get($fontSize,xx-large)
      margin-bottom: 10px
      text-align: left
    .tip
      font-size: map-get($fontSize,small)
      color: $subFontColor
  .title_bar.center
    margin: 20px 0 10px 0
  .newslist
    font-size: 15px
    .cell
      +NewsStatusTag
    .news-title
      cursor: pointer
      color: $mainColorDark
      text-decoration: underline
    ::v-deep .el-table
      +basicTable
    .icon-info
      padding-left: 5px
    .nameWrap
      display: flex
      align-items: center
    .alertHighlight
      color: $dangerColor

</style>
